export enum POPULAR_SEARCH_TERM_NEWS_SORT {
  SIMILARL = 'sim',  // 유사도 순
  DATE = 'date',     // 기사 날짜 기준 내림 차순
}

export enum POPULAR_SEARCH_TERM_OPTION_KEY {
  TERM_VISIBLE_COUNT = 'termVisibleCount',                      // 게임 내 인기 검색어 표시 수
  TERM_ROLLING_ENABLED = 'termRollingEnabled',                  // 인게임 내 인기 검색어 롤링 활성 여부
  TERM_ROLLING_SECOND = 'termRollingSecond',                    // 인게임 내 인기 검색어 롤링 주기
  NEWS_COUNT_PER_TERM = 'newsCountPerTerm',                     // 인기 검색어 당 뉴스 수
  NEWS_READ_HISTORY_LIFE_TIME = 'newsReadHistoryLifeTime',     // 인기 검색어 읽은 기록 보관 기간
  TERM_NEWS_REFRESH_MINUTE = 'termNewsRefreshMinute',          // 인기 검색어 뉴스 갱신 주기
}
